import { RootState } from '@ui/store';
// eslint-disable-next-line no-restricted-imports
import { useSelector as reduxUseSelector } from 'react-redux';

export const useSelector = reduxUseSelector.withTypes<RootState>();
